import { Modal, ModalBody } from '@windmill/react-ui';
import FormattedText from 'src/components/_common/FormattedText/FormattedText';
import { FormQuestion } from 'src/models/form';

interface HelpTextModalProps {
  question: FormQuestion;
  isOpen: boolean;
  close: () => void;
}

export default function HelpTextModal({ question, isOpen, close }: HelpTextModalProps) {
  return (
    (
      <Modal isOpen={isOpen} onClose={close} style={{ margin: 'auto' }}>
        <div className="mt-4 mb-2">
          <FormattedText text={question.text} paragraphClassName="text-lg font-semibold text-gray-700" />
        </div>
        <ModalBody>
          <div className="flex-wrap">
            <FormattedText text={question.helpText} />
          </div>
        </ModalBody>
      </Modal>
    )
  );
}
